import { jsx as _jsx } from "react/jsx-runtime";
import { useGraph } from "../Contexts/GraphContext";
import { useCurrentNodes } from "../Contexts/CurrentNodesContext";
import { SearchBar } from "../Styling/Components/Search/SearchBar";
import styled from "styled-components";
import { VariableManualPanelStyling } from "./Layouts/Panels/PanelStylings";
const SearchBar_override = styled(SearchBar) `
  ${VariableManualPanelStyling};
  color: "crimson";
`;
export function VMSearchBar({ association }) {
    const { executeNodeSearch } = useGraph();
    const { nodesManager, setNodesManager } = useCurrentNodes();
    const triggerSearch = (searchText) => {
        if (!searchText.trim().length)
            return;
        let id_searchNode = executeNodeSearch(searchText);
        let newManager = nodesManager.setCurrentNode(association.proposal_id, association.kind, id_searchNode);
        setNodesManager(newManager);
    };
    const onEnterTriggerSearch = (key, searchText) => {
        if (key === "Enter")
            triggerSearch(searchText);
    };
    return (_jsx(SearchBar, { callbackTriggerSearch: triggerSearch, callbackInputKeyDown: onEnterTriggerSearch }));
}
